// extracted by mini-css-extract-plugin
export default {"account":"account__10A_-","createAccount":"createAccount__23q37","login":"login__1bV88"};